import { useMutation } from "urql";

import { TrackActivityDocument } from "../../../graphql/generated";

export function useTrack() {
  return useMutation(TrackActivityDocument);
}
